module.exports = __webpack_public_path__ + "img/Slime_Staff.722bf416.gif";